module.exports = __webpack_public_path__ + "img/Bg1@2x.0e04481b.png";